import {ChatbotEvent} from "@proto/chatbot/v1alpha/chatbot"

export const EventTypeProcessingQuery = "processing_query"
export const EventTypeProcessingContent = "processing_content"
export const EventTypeProcessingResponse = "processing_response"
export const EventTypeUser = "user"
export const EventTypeRelated = "related"
export const EventTypeProducts = "products"
export const EventTypeProduct = "product"
export const EventTypeStream = "stream"
export const EventTypeSelect = "select"
export const EventTypeSelectWithText = "select_with_text"
export const EventTypeMessage = "message"
export const EventTypeHeader = "header"
export const EventTypeSponsoredContent = "sponsored_content"
export const EventTypeSponsoredAdverts = "sponsored_adverts"
export const EventTypeSponsoredSignOff = "sponsored_signoff"
export const EventTypeStart = "start"
export const EventTypeArticleHitsReport = "article_hits_report"
export const EventTypeArticleHitsIteration = "article_hits_iteration"
export const EventTypeTable = "table"
export const EventTypeSimilarSegment = "similar_segment"
export const EventTypeSegmentInfo = "segment_info"

export const messagesFromSocket = (evt: {data: string}): string[] => {
    const messages: string[] = []
    const mm = evt.data.split('{"type":')
    if (mm.length > 1) {
        for (let i = 0; i < mm.length; i++) {
            if (mm[i].length > 0) {
                const msg = '{"type":' + mm[i]
                messages.push(msg)
            }
        }
    } else {
        messages.push(evt.data)
    }
    return messages
}

export const messageParse = (msg: string): ChatbotEvent | false => {
    try {
        return JSON.parse(msg)
    } catch (e) {
        console.error(e)
        return false
    }
}
